import React from "react";
import { useIntl } from "react-intl";
import { Button, Form } from "@masterteam/mt-design-react";

import { ReactComponent as DeleteIcon } from "../../../../../assets/images/close.svg";

import "./style.scss";

const { Field } = Form;

function Step({
  index,
  data = {},
  hideRemove,
  readOnly,
  approvers = [],
  groups = [],
  onChange,
  errors,
  removeItem,
}) {
  const intl = useIntl();

  function getOptions() {
    return data?.isGroup ? groups : approvers;
  }

  return (
    <div className="kpi-config__form__workflow-tab__step-item">
      <div className="kpi-config__form__workflow-tab__step-item__step-name">
        <div className="line" />
        <div className="kpi-config__form__workflow-tab__step-item__step-name__circle">
          {index + 1}
        </div>
      </div>
      <div className="kpi-config__form__workflow-tab__step-item__column">
        <Field
          name={`Workflows[0].WorkflowSteps[${index}].EnglishName`}
          disabled={readOnly}
          hideLabel
          hideErrorMessage
          inputProps={{
            error: errors?.EnglishName,
            placeholder: intl.formatMessage({ id: "common.step-english-name" }),
          }}
        />
      </div>
      <div className="kpi-config__form__workflow-tab__step-item__column">
        <Field
          name={`Workflows[0].WorkflowSteps[${index}].ArabicName`}
          disabled={readOnly}
          hideLabel
          hideErrorMessage
          inputProps={{
            error: errors?.ArabicName,
            placeholder: intl.formatMessage({ id: "common.step-arabic-name" }),
          }}
        />
      </div>
      <div className={`kpi-config__form__workflow-tab__step-item__column`}>
        <Field
          type="select"
          name={`Workflows[0].WorkflowSteps[${index}].Approver`}
          disabled={readOnly || index == 0}
          hideLabel
          hideErrorMessage
          inputProps={{
            error: errors?.Approver,
            options: getOptions(),
            getOptionLabel: (e) => (data?.isGroup ? e?.Title : e?.English),
            getOptionValue: (e) => (data?.isGroup ? e?.ID : e?.Value),
            maxMenuHeight: "100px",
            placeholder: intl.formatMessage({ id: "kpi-type.approver" }),
          }}
        />
      </div>
      <div className="kpi-config__form__workflow-tab__step-item__column checkbox-control">
        <Field
          type="checkbox"
          name={`Workflows[0].WorkflowSteps[${index}].isGroup`}
          label={intl.formatMessage({ id: "kpi-type.is-group" })}
          disabled={readOnly || index == 0}
          inputProps={{
            name: `Workflows[0].WorkflowSteps[${index}].isGroup`,
            onChange: (name, value) => {
              onChange(name, !value);
              onChange(`Workflows[0].WorkflowSteps[${index}].Approver`, null);
            },
          }}
        />
      </div>
      <div className="kpi-config__form__workflow-tab__step-item__column actions-control">
        {!hideRemove && (
          <Button
            onClick={() => removeItem(index)}
            variant="error"
            shape="square"
            fill="none"
            tooltip-position="buttom"
            tooltip={intl.formatMessage({ id: "common.delete" })}
            Icon={DeleteIcon}
            disabled={readOnly}
          />
        )}
      </div>
    </div>
  );
}

export default Step;
